import React, { useMemo } from 'react';
import { Select, Tooltip } from 'antd';
import cn from 'classnames';
import { getRoomOptionCreator } from '../../../../../../../helpers/dspx-utils';
import { useFilterChange } from '../../../../model/useFilterChange';
import styles from '../SelectRoomsRow.module.scss';
import { createTreeFilter } from './options';

export const useSetFilterChanged = () => {
  const { markFilterChanged } = useFilterChange();

  return markFilterChanged;
};

export const useFilteredItems = ({ items, enabled, value, cb }) => {
  const data = useMemo(() => {
    if (!enabled) return { items };

    const filteredItems = createTreeFilter(value).run(items);

    return {
      items: filteredItems,
      ...(typeof cb === 'function' ? { cbData: cb(filteredItems) } : {}),
    };
  }, [items, enabled, value, cb]);

  return data;
};

export const getCollectLeavesTypeFlat = (node, result = {}) => {
  node.forEach((option) => {
    const { label, children, typeId, typeName } = option;

    if (label) {
      getCollectLeavesTypeFlat(children, result);
    }

    if (!typeId) return null;

    if (!result[typeId]) {
      result[typeId] = {
        id: typeId,
        name: typeName,
        count: 0,
      };
    }

    result[typeId].count += 1;
  });

  return result;
};

export const createOptionsTypeFlatForRender = (items) => {
  return items.map((option) => (
    <Select.Option
      key={Number(option.id)}
      label={option.name}
      searchtext={option.name}
    >
      {option.name}
    </Select.Option>
  ));
};

export const createOptionsForRender = ({
  items,
  createOption,
  groupValue,
  filtered = false,
  valueFiltered = [],
}) => {
  return items.map((option) => {
    const { label, level, children, groupValue: optGroupVal } = option;

    if (label) {
      return (
        <Select.OptGroup
          key={label}
          label={
            <span className={cn(styles.level, styles[`level-${level}`])}>
              {createGroupLabel(option)}
            </span>
          }
        >
          {createOptionsForRender({
            items: children,
            createOption,
            groupValue: optGroupVal,
            filtered,
            valueFiltered,
          })}
        </Select.OptGroup>
      );
    }

    if (
      filtered &&
      valueFiltered.length > 0 &&
      !valueFiltered.includes(String(option.typeId))
    ) {
      return null;
    }

    return createOption({ option, groupValue });
  });
};

export const optionCreators = {
  floor: createFloorOption,
  room: createRoomOption,
};

// helpers
function createGroupLabel({ label, level }) {
  return [level === 2 && '●', label].filter(Boolean).join(' ');
}

function createRoomOption({ option }) {
  const create = getRoomOptionCreator();
  return create(option);
}

const visibleCharAmount = 6;
function createFloorOption({ option, groupValue }) {
  const value = `${groupValue}_${option}`;
  const content = createFloorOptionContent(option);

  return (
    <Select.Option
      key={value}
      value={value}
      label={`${content} (подъезд ${groupValue})`}
    >
      <Tooltip title={content.length > visibleCharAmount ? content : ''}>
        {content}
      </Tooltip>
    </Select.Option>
  );
}

function createFloorOptionContent(val) {
  return val.startsWith('-')
    ? `Подвал. Уровень - ${val.slice(1)}`
    : `Этаж ${val}`;
}
